/**
 * drawer-content-builder.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { shouldRenderMobileLayout } from 'utils/app-context';
import AppBar from 'components/app-bar';
import ScrollableStickyHeader from 'components/scrollable-sticky-header';
import DesktopContentHeader from './desktop-content-header';


const useStyles = makeStyles(theme => ({
  drawerContentWrapper: {
    paddingBottom: 150,
    overflowY: 'auto', 
    overflowX: 'hidden', 
    scrollBehavior: 'smooth',
  }
}));


export default function DrawerContentBuilder(props) {
  const { 
    mobileAppBar,
    desktopHeader,
    stickyHeader,
    children,
  } = props;
  const classes = useStyles();


  const mobileAppBarSection = (mobileAppBar && shouldRenderMobileLayout())
    ? mobileAppBar.content || (
      <AppBar
        title={mobileAppBar.title}
        leftActions={mobileAppBar.leftActions}
        rightActions={mobileAppBar.rightActions}
        recordGroupType={mobileAppBar.recordGroupType}
      />
    ) : null;


  const desktopHeaderSection = (!shouldRenderMobileLayout() && desktopHeader)
    ? desktopHeader.content || (
      <DesktopContentHeader
        title={desktopHeader.title}
        actions={desktopHeader.actions}
      />
    ) : null;


  const childrenWrap = (triggerElement, desktopHeader) => (
    <div 
      className={classes.drawerContentWrapper}
      children={<>
        {typeof(children) === 'function' 
          ? children(triggerElement, desktopHeader) 
          : <>
            {desktopHeaderSection}
            {triggerElement}
            {children}
          </>}
      </>}
    />
  );
  

  const scrollableSection = stickyHeader
    ? (
      <ScrollableStickyHeader
        headerContent={stickyHeader.content || desktopHeaderSection}
        triggerOffset={stickyHeader.offset || -70}
        children={triggerElement => childrenWrap(triggerElement, desktopHeaderSection)}
      />
    ) 
    : childrenWrap(null, desktopHeaderSection);


  return (
    <>
      {mobileAppBarSection}
      {scrollableSection}
    </>
  );
}

